<template>
  <th v-if="isHeader">
  </th>
  <td v-else class="drag-handle-cell">
    <div class="drag-handle">
      <i class="fa fa-grip-vertical text-muted"></i>
    </div>
  </td>
</template>

<script>
import VuetableFieldMixin from 'vuetable-2/src/components/VuetableFieldMixin'

export default {
  mixins: [VuetableFieldMixin],
  props: {
    rowData: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    }
  }
}
</script>

<style scoped>
.drag-handle-cell {
  cursor: move;
  user-select: none;
  padding: 8px !important;
  vertical-align: middle;
}

.drag-handle {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  opacity: 0.6;
  transition: opacity 0.2s ease;
}

.drag-handle:hover {
  opacity: 1;
}

.drag-handle i {
  font-size: 14px;
}
</style>


// WEBPACK FOOTER //
// VueTableDragHandle.vue?11ee1d10